let nextId = 1;

const getNextId = () => {
    nextId += 1;
    return nextId;
};

const setMinId = (minId) => {
    if (nextId <= minId) {
        nextId = minId + 1;
    }
};

const result = {
    getNextId,
    setMinId
};

export default result;
